"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitInput = exports.UiKitInputStyle = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const react_3 = require("react");
const consistency_1 = require("../../consistency");
const UiKitIcons_1 = require("../../UiKitIcons");
exports.UiKitInputStyle = {
    height: '36px',
    fontSize: '14px',
    color: consistency_1.consistency.gray90,
    padding: '8px 12px',
    border: `1px solid ${consistency_1.consistency.gray20}`,
    borderRadius: consistency_1.consistency.borderRadius,
    backgroundColor: consistency_1.consistency.white,
};
const UiKitInput = (props) => {
    const [show, setShow] = (0, react_3.useState)(false);
    const handleClick = () => setShow(!show);
    return (react_1.default.createElement(react_2.InputGroup, { size: props.size ?? 'sm' },
        react_1.default.createElement(react_2.Input, { style: exports.UiKitInputStyle, placeholder: props.placeholder, type: props.isPassword ? (show ? 'text' : 'password') : 'text', value: props.value, onChange: evt => props.onChange(evt.target.value) }),
        props.isPassword && (react_1.default.createElement(react_2.InputRightElement, { h: "full" }, show ? (react_1.default.createElement(react_2.Icon, { width: '19px', height: '16px', viewBox: '0 0 16 10', onClick: handleClick, cursor: "pointer", boxSize: "16px" },
            react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.Visible, null))) : (react_1.default.createElement(react_2.Icon, { width: '19px', height: '16px', viewBox: '0 0 19 16', onClick: handleClick, cursor: "pointer", boxSize: "16px" },
            react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.NotVisible, null)))))));
};
exports.UiKitInput = UiKitInput;
